














 









































































const node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "meetingId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "updates"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "meetingId",
    "variableName": "meetingId"
  },
  {
    "kind": "Variable",
    "name": "updates",
    "variableName": "updates"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StandardMutationError",
      "kind": "LinkedField",
      "name": "error",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ErrorPayload",
  "abstractKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNavigableByFacilitator",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVoting",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "ServiceField",
  "kind": "LinkedField",
  "name": "serviceField",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stageId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "picture",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preferredName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "facilitatorStageId",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phaseType",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isComplete",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNavigable",
  "storageKey": null
},
v20 = [
  (v3/*: any*/),
  (v16/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "phases",
    "plural": true,
    "selections": [
      (v17/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "stages",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v21 = {
  "kind": "InlineDataFragmentSpread",
  "name": "fromStageIdToUrl_meeting",
  "selections": (v20/*: any*/),
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v22 = {
  "kind": "InlineDataFragmentSpread",
  "name": "updateLocalStage_meeting",
  "selections": (v20/*: any*/),
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingType",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "facilitatorUserId",
  "storageKey": null
},
v25 = [
  (v3/*: any*/)
],
v26 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "stages",
    "plural": true,
    "selections": (v25/*: any*/),
    "storageKey": null
  }
],
v27 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "localStage",
      "plural": false,
      "selections": (v25/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "localPhase",
      "plural": false,
      "selections": (v26/*: any*/),
      "storageKey": null
    }
  ]
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "queryString",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectedProjectsIds",
  "storageKey": null
},
v30 = [
  (v28/*: any*/)
],
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectKeyFilters",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finalScore",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamProject",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "descriptionHTML",
  "storageKey": null
},
v39 = {
  "kind": "InlineFragment",
  "selections": [
    (v34/*: any*/),
    (v35/*: any*/),
    (v10/*: any*/),
    (v36/*: any*/),
    (v37/*: any*/),
    (v38/*: any*/)
  ],
  "type": "AzureDevOpsWorkItem",
  "abstractKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueKey",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v42 = {
  "alias": "jiraUrl",
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraIssueField",
  "kind": "LinkedField",
  "name": "possibleEstimationFields",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fieldId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fieldName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "missingEstimationFieldHint",
  "storageKey": null
},
v45 = {
  "alias": "jiraProjectId",
  "args": null,
  "kind": "ScalarField",
  "name": "projectId",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueType",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "possibleEstimationFieldNames",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodyHTML",
  "storageKey": null
},
v50 = {
  "alias": "ghUrl",
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "_xGitHubRepository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameWithOwner",
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iid",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "descriptionHtml",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "webUrl",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectId",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plaintextContent",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamId",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "integrationHash",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "TemplateScaleRef",
  "kind": "LinkedField",
  "name": "scale",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TemplateScaleValue",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        (v8/*: any*/),
        (v9/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "TemplateDimensionRef",
  "kind": "LinkedField",
  "name": "dimensionRef",
  "plural": false,
  "selections": [
    (v60/*: any*/),
    (v3/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/)
  ],
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingId",
  "storageKey": null
},
v64 = [
  (v14/*: any*/),
  (v15/*: any*/),
  (v3/*: any*/)
],
v65 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "hoveringUsers",
  "plural": true,
  "selections": (v64/*: any*/),
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "discussionId",
  "storageKey": null
},
v67 = [
  (v28/*: any*/),
  (v3/*: any*/)
],
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientId",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMemberIntegrationAuthOAuth2",
  "kind": "LinkedField",
  "name": "auth",
  "plural": false,
  "selections": (v25/*: any*/),
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isJQL",
  "storageKey": null
},
v72 = [
  (v3/*: any*/),
  (v28/*: any*/),
  (v71/*: any*/),
  (v31/*: any*/)
],
v73 = [
  (v3/*: any*/),
  (v7/*: any*/)
],
v74 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "tenantId",
    "storageKey": null
  },
  (v69/*: any*/)
],
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSpectating",
  "storageKey": null
},
v76 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isNewMeetingStage"
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readyCount",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isViewerReady",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "suggestedTimeLimit",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduledEndTime",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "filters": null,
  "handle": "localTime",
  "key": "",
  "kind": "ScalarHandle",
  "name": "scheduledEndTime"
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "suggestedEndTime",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAsync",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeRemaining",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMember",
  "kind": "LinkedField",
  "name": "teamMember",
  "plural": false,
  "selections": (v64/*: any*/),
  "storageKey": null
},
v86 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamMemberId",
      "storageKey": null
    },
    (v85/*: any*/)
  ],
  "type": "NewMeetingTeamMemberStage",
  "abstractKey": "__isNewMeetingTeamMemberStage"
},
v87 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamMember",
      "kind": "LinkedField",
      "name": "teamMember",
      "plural": false,
      "selections": [
        (v12/*: any*/),
        (v15/*: any*/),
        (v14/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "CheckInStage",
  "abstractKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localScheduledEndTime",
  "storageKey": null
},
v89 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isNewMeetingPhase"
},
v90 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkInQuestion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingGreeting",
      "kind": "LinkedField",
      "name": "checkInGreeting",
      "plural": false,
      "selections": [
        (v57/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "language",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CheckInPhase",
  "abstractKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
},
v92 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TeamMemberIntegrationAuthWebhook",
    "kind": "LinkedField",
    "name": "auth",
    "plural": false,
    "selections": [
      (v68/*: any*/),
      (v3/*: any*/)
    ],
    "storageKey": null
  }
],
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showSidebar",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRightDrawerOpen",
  "storageKey": null
},
v95 = [
  (v40/*: any*/),
  (v41/*: any*/),
  (v38/*: any*/),
  (v42/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdatePokerScopeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updatePokerScope",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EstimateStage",
                "kind": "LinkedField",
                "name": "newStages",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useMakeStageSummaries_stages"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PokerEstimateHeaderCard_stage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PokerCardDeckStage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EstimatePhaseAreaStage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "JiraFieldDimensionDropdown_stage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EstimateDimensionColumn_stage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EstimatePhaseDiscussionDrawerEstimateStage"
                  },
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TemplateDimensionRef",
                    "kind": "LinkedField",
                    "name": "dimensionRef",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TemplateScaleRef",
                        "kind": "LinkedField",
                        "name": "scale",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TemplateScaleValue",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": true,
                            "selections": [
                              (v8/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EstimateUserScore",
                    "kind": "LinkedField",
                    "name": "scores",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      (v9/*: any*/),
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v15/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PokerMeeting",
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PokerMeeting_meeting"
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "useInitialSafeRoute_meeting",
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v3/*: any*/),
                          (v23/*: any*/),
                          (v16/*: any*/),
                          (v24/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "phases",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              (v17/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "stages",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v19/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v27/*: any*/)
                        ],
                        "type": "NewMeeting",
                        "abstractKey": "__isNewMeeting"
                      }
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "useUpdatedSafeRoute_meeting",
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v3/*: any*/),
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "phases",
                            "plural": true,
                            "selections": (v26/*: any*/),
                            "storageKey": null
                          },
                          (v27/*: any*/)
                        ],
                        "type": "NewMeeting",
                        "abstractKey": "__isNewMeeting"
                      }
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "phases",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EstimateStage",
                            "kind": "LinkedField",
                            "name": "stages",
                            "plural": true,
                            "selections": (v25/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "EstimatePhase",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GitLabSearchQuery",
                        "kind": "LinkedField",
                        "name": "gitlabSearchQuery",
                        "plural": false,
                        "selections": [
                          (v28/*: any*/),
                          (v29/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GitHubSearchQuery",
                        "kind": "LinkedField",
                        "name": "githubSearchQuery",
                        "plural": false,
                        "selections": (v30/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "JiraSearchQuery",
                        "kind": "LinkedField",
                        "name": "jiraSearchQuery",
                        "plural": false,
                        "selections": [
                          (v28/*: any*/),
                          (v31/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ParabolSearchQuery",
                        "kind": "LinkedField",
                        "name": "parabolSearchQuery",
                        "plural": false,
                        "selections": (v30/*: any*/),
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "UpdatePokerScopeSuccess",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdatePokerScopeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updatePokerScope",
        "plural": false,
        "selections": [
          (v32/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EstimateStage",
                "kind": "LinkedField",
                "name": "newStages",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v33/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Task",
                    "kind": "LinkedField",
                    "name": "task",
                    "plural": false,
                    "selections": [
                      (v34/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "integration",
                        "plural": false,
                        "selections": [
                          (v32/*: any*/),
                          (v3/*: any*/),
                          (v39/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v40/*: any*/),
                              (v41/*: any*/),
                              (v38/*: any*/),
                              (v42/*: any*/),
                              (v43/*: any*/),
                              (v44/*: any*/)
                            ],
                            "type": "JiraIssue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v40/*: any*/),
                              (v41/*: any*/),
                              (v38/*: any*/),
                              (v42/*: any*/),
                              (v45/*: any*/),
                              (v46/*: any*/),
                              (v47/*: any*/)
                            ],
                            "type": "JiraServerIssue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v34/*: any*/),
                              (v48/*: any*/),
                              (v49/*: any*/),
                              (v50/*: any*/),
                              (v51/*: any*/)
                            ],
                            "type": "_xGitHubIssue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v34/*: any*/),
                              (v52/*: any*/),
                              (v53/*: any*/),
                              (v54/*: any*/),
                              (v55/*: any*/)
                            ],
                            "type": "_xGitLabIssue",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      (v56/*: any*/),
                      (v57/*: any*/),
                      (v58/*: any*/),
                      (v59/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  (v61/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EstimateUserScore",
                    "kind": "LinkedField",
                    "name": "scores",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      (v9/*: any*/),
                      (v3/*: any*/),
                      (v62/*: any*/),
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v63/*: any*/),
                  (v11/*: any*/),
                  (v58/*: any*/),
                  (v65/*: any*/),
                  (v66/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PokerMeeting",
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endedAt",
                    "storageKey": null
                  },
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "phases",
                    "plural": true,
                    "selections": [
                      (v32/*: any*/),
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "stages",
                        "plural": true,
                        "selections": [
                          (v32/*: any*/),
                          (v3/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v6/*: any*/),
                              (v66/*: any*/)
                            ],
                            "type": "EstimateStage",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EstimateStage",
                            "kind": "LinkedField",
                            "name": "stages",
                            "plural": true,
                            "selections": [
                              (v33/*: any*/),
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Task",
                                "kind": "LinkedField",
                                "name": "task",
                                "plural": false,
                                "selections": [
                                  (v34/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "integration",
                                    "plural": false,
                                    "selections": [
                                      (v32/*: any*/),
                                      (v3/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v34/*: any*/),
                                          (v35/*: any*/),
                                          (v37/*: any*/),
                                          (v10/*: any*/),
                                          (v36/*: any*/),
                                          (v38/*: any*/)
                                        ],
                                        "type": "AzureDevOpsWorkItem",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v40/*: any*/),
                                          (v41/*: any*/),
                                          (v43/*: any*/),
                                          (v44/*: any*/),
                                          (v38/*: any*/),
                                          (v42/*: any*/)
                                        ],
                                        "type": "JiraIssue",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v40/*: any*/),
                                          (v41/*: any*/),
                                          (v45/*: any*/),
                                          (v46/*: any*/),
                                          (v47/*: any*/),
                                          (v38/*: any*/),
                                          (v42/*: any*/)
                                        ],
                                        "type": "JiraServerIssue",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v34/*: any*/),
                                          (v48/*: any*/),
                                          (v51/*: any*/),
                                          (v49/*: any*/),
                                          (v50/*: any*/)
                                        ],
                                        "type": "_xGitHubIssue",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v34/*: any*/),
                                          (v52/*: any*/),
                                          (v55/*: any*/),
                                          (v53/*: any*/),
                                          (v54/*: any*/)
                                        ],
                                        "type": "_xGitLabIssue",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v3/*: any*/),
                                  (v59/*: any*/),
                                  (v58/*: any*/),
                                  (v56/*: any*/),
                                  (v57/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EstimateUserScore",
                                "kind": "LinkedField",
                                "name": "scores",
                                "plural": true,
                                "selections": [
                                  (v12/*: any*/),
                                  (v3/*: any*/),
                                  (v9/*: any*/),
                                  (v62/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v5/*: any*/),
                              (v61/*: any*/),
                              (v11/*: any*/),
                              (v63/*: any*/),
                              (v58/*: any*/),
                              (v65/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "EstimatePhase",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  (v58/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PokerMeetingMember",
                    "kind": "LinkedField",
                    "name": "viewerMeetingMember",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamMember",
                        "kind": "LinkedField",
                        "name": "teamMember",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamMemberIntegrations",
                            "kind": "LinkedField",
                            "name": "integrations",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "GitHubIntegration",
                                "kind": "LinkedField",
                                "name": "github",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GitHubSearchQuery",
                                    "kind": "LinkedField",
                                    "name": "githubSearchQueries",
                                    "plural": true,
                                    "selections": (v67/*: any*/),
                                    "storageKey": null
                                  },
                                  (v3/*: any*/),
                                  (v68/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "scope",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "GitLabIntegration",
                                "kind": "LinkedField",
                                "name": "gitlab",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "IntegrationProviderOAuth2",
                                    "kind": "LinkedField",
                                    "name": "cloudProvider",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v69/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "serverBaseUrl",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "projects",
                                    "plural": true,
                                    "selections": [
                                      (v32/*: any*/),
                                      (v3/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "fullPath",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "_xGitLabProject",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v70/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "IntegrationProviderOAuth2",
                                    "kind": "LinkedField",
                                    "name": "sharedProviders",
                                    "plural": true,
                                    "selections": [
                                      (v69/*: any*/),
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AtlassianIntegration",
                                "kind": "LinkedField",
                                "name": "atlassian",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "JiraSearchQuery",
                                    "kind": "LinkedField",
                                    "name": "jiraSearchQueries",
                                    "plural": true,
                                    "selections": (v72/*: any*/),
                                    "storageKey": null
                                  },
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "JiraRemoteProject",
                                    "kind": "LinkedField",
                                    "name": "projects",
                                    "plural": true,
                                    "selections": (v73/*: any*/),
                                    "storageKey": null
                                  },
                                  (v68/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "JiraServerIntegration",
                                "kind": "LinkedField",
                                "name": "jiraServer",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TeamMemberIntegrationAuthOAuth1",
                                    "kind": "LinkedField",
                                    "name": "auth",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v68/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "IntegrationProviderOAuth1",
                                    "kind": "LinkedField",
                                    "name": "sharedProviders",
                                    "plural": true,
                                    "selections": (v25/*: any*/),
                                    "storageKey": null
                                  },
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "JiraServerRemoteProject",
                                    "kind": "LinkedField",
                                    "name": "projects",
                                    "plural": true,
                                    "selections": (v73/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "JiraSearchQuery",
                                    "kind": "LinkedField",
                                    "name": "searchQueries",
                                    "plural": true,
                                    "selections": (v72/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AzureDevOpsIntegration",
                                "kind": "LinkedField",
                                "name": "azureDevOps",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "IntegrationProviderOAuth2",
                                    "kind": "LinkedField",
                                    "name": "cloudProvider",
                                    "plural": false,
                                    "selections": (v74/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "IntegrationProviderOAuth2",
                                    "kind": "LinkedField",
                                    "name": "sharedProviders",
                                    "plural": true,
                                    "selections": (v74/*: any*/),
                                    "storageKey": null
                                  },
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AzureDevOpsRemoteProject",
                                    "kind": "LinkedField",
                                    "name": "projects",
                                    "plural": true,
                                    "selections": (v73/*: any*/),
                                    "storageKey": null
                                  },
                                  (v70/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          (v58/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      (v75/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PokerMeetingMember",
                    "kind": "LinkedField",
                    "name": "meetingMembers",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v75/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "init",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": "init",
                    "args": null,
                    "filters": null,
                    "handle": "localPoker",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "id"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "phases",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "stages",
                            "plural": true,
                            "selections": [
                              (v76/*: any*/),
                              (v77/*: any*/),
                              (v78/*: any*/),
                              (v17/*: any*/),
                              (v79/*: any*/),
                              (v80/*: any*/),
                              (v81/*: any*/),
                              (v82/*: any*/),
                              (v83/*: any*/),
                              (v84/*: any*/),
                              (v86/*: any*/),
                              (v87/*: any*/),
                              {
                                "kind": "ClientExtension",
                                "selections": [
                                  (v88/*: any*/)
                                ]
                              }
                            ],
                            "storageKey": null
                          },
                          (v89/*: any*/),
                          (v90/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v23/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "viewerMeetingMember",
                        "plural": false,
                        "selections": [
                          (v32/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "team",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Organization",
                            "kind": "LinkedField",
                            "name": "organization",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "tierLimitExceededAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrganizationFeatureFlags",
                                "kind": "LinkedField",
                                "name": "featureFlags",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "noAISummary",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamMember",
                            "kind": "LinkedField",
                            "name": "teamMembers",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "email",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "meetingMembers",
                        "plural": true,
                        "selections": [
                          (v32/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v91/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastSeenAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastSeenAtURLs",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v12/*: any*/),
                          (v85/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamMember",
                        "kind": "LinkedField",
                        "name": "facilitator",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v91/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          (v58/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamMemberIntegrations",
                            "kind": "LinkedField",
                            "name": "integrations",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MattermostIntegration",
                                "kind": "LinkedField",
                                "name": "mattermost",
                                "plural": false,
                                "selections": (v92/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MSTeamsIntegration",
                                "kind": "LinkedField",
                                "name": "msTeams",
                                "plural": false,
                                "selections": (v92/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SlackIntegration",
                                "kind": "LinkedField",
                                "name": "slack",
                                "plural": false,
                                "selections": [
                                  (v68/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "defaultTeamChannelId",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SlackNotification",
                                    "kind": "LinkedField",
                                    "name": "notifications",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "channelId",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "event",
                                        "storageKey": null
                                      },
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "locked",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Organization",
                        "kind": "LinkedField",
                        "name": "organization",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrganizationUser",
                            "kind": "LinkedField",
                            "name": "viewerOrganizationUser",
                            "plural": false,
                            "selections": (v25/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "localStage",
                            "plural": false,
                            "selections": [
                              (v32/*: any*/),
                              (v3/*: any*/),
                              (v76/*: any*/),
                              (v18/*: any*/),
                              (v77/*: any*/),
                              (v78/*: any*/),
                              (v17/*: any*/),
                              (v79/*: any*/),
                              (v80/*: any*/),
                              (v81/*: any*/),
                              (v82/*: any*/),
                              (v83/*: any*/),
                              (v84/*: any*/),
                              (v88/*: any*/),
                              (v87/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "votes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isRevealed",
                                    "storageKey": null
                                  }
                                ],
                                "type": "TeamHealthStage",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "localPhase",
                            "plural": false,
                            "selections": [
                              (v32/*: any*/),
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "stages",
                                "plural": true,
                                "selections": [
                                  (v32/*: any*/),
                                  (v3/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v4/*: any*/),
                                  (v86/*: any*/),
                                  (v76/*: any*/),
                                  (v77/*: any*/),
                                  (v78/*: any*/),
                                  (v17/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v89/*: any*/),
                              (v17/*: any*/),
                              (v90/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v93/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RetroReflectionGroup",
                            "kind": "LinkedField",
                            "name": "reflectionGroups",
                            "plural": true,
                            "selections": (v25/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "RetrospectiveMeeting",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              (v94/*: any*/)
                            ]
                          }
                        ],
                        "type": "PokerMeeting",
                        "abstractKey": null
                      }
                    ],
                    "type": "NewMeeting",
                    "abstractKey": "__isNewMeeting"
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "localStage",
                        "plural": false,
                        "selections": [
                          (v32/*: any*/),
                          (v3/*: any*/),
                          (v18/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TemplateDimensionRef",
                                "kind": "LinkedField",
                                "name": "dimensionRef",
                                "plural": false,
                                "selections": [
                                  (v60/*: any*/),
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EstimateUserScore",
                                "kind": "LinkedField",
                                "name": "scores",
                                "plural": true,
                                "selections": [
                                  (v12/*: any*/),
                                  (v9/*: any*/),
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v6/*: any*/),
                              (v66/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Task",
                                "kind": "LinkedField",
                                "name": "task",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v34/*: any*/),
                                  (v56/*: any*/),
                                  (v57/*: any*/),
                                  (v58/*: any*/),
                                  (v59/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "integration",
                                    "plural": false,
                                    "selections": [
                                      (v32/*: any*/),
                                      (v3/*: any*/),
                                      (v39/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v95/*: any*/),
                                        "type": "JiraIssue",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v95/*: any*/),
                                        "type": "JiraServerIssue",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v48/*: any*/),
                                          (v34/*: any*/),
                                          (v49/*: any*/),
                                          (v50/*: any*/)
                                        ],
                                        "type": "_xGitHubIssue",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v53/*: any*/),
                                          (v34/*: any*/),
                                          (v54/*: any*/),
                                          (v52/*: any*/)
                                        ],
                                        "type": "_xGitLabIssue",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "EstimateStage",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v93/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "localPhase",
                        "plural": false,
                        "selections": [
                          (v32/*: any*/),
                          (v17/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GitHubSearchQuery",
                        "kind": "LinkedField",
                        "name": "githubSearchQuery",
                        "plural": false,
                        "selections": (v67/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GitLabSearchQuery",
                        "kind": "LinkedField",
                        "name": "gitlabSearchQuery",
                        "plural": false,
                        "selections": [
                          (v29/*: any*/),
                          (v28/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "JiraSearchQuery",
                        "kind": "LinkedField",
                        "name": "jiraSearchQuery",
                        "plural": false,
                        "selections": [
                          (v28/*: any*/),
                          (v71/*: any*/),
                          (v3/*: any*/),
                          (v31/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "JiraSearchQuery",
                        "kind": "LinkedField",
                        "name": "jiraServerSearchQuery",
                        "plural": false,
                        "selections": [
                          (v31/*: any*/),
                          (v28/*: any*/),
                          (v71/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ParabolSearchQuery",
                        "kind": "LinkedField",
                        "name": "parabolSearchQuery",
                        "plural": false,
                        "selections": [
                          (v28/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "statusFilters",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AzureDevOpsSearchQuery",
                        "kind": "LinkedField",
                        "name": "azureDevOpsSearchQuery",
                        "plural": false,
                        "selections": [
                          (v28/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isWIQL",
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          (v31/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v94/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isCommentUnread",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "UpdatePokerScopeSuccess",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "m_iwlMEP-VOeO3Weu9Gzc79w",
    "metadata": {},
    "name": "UpdatePokerScopeMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node ).hash = "7c439a86f7fb0a79cbdb4b4bd66897b1";

export default node;
